var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',[_vm._v(" Ключевые даты ")]),_c('tricolor-line'),_c('div',{staticClass:"key-dates"},[_c('div',{staticClass:"key-dates__container"},_vm._l((_vm.getKeyDates),function(card,index){return _c('key-date-card',{key:`keyDatesCards${index}`,attrs:{"card":card}})}),1),_c('time-line',{attrs:{"dates":_vm.getKeyDates}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }